import InputLabel from '@mui/material/InputLabel';

import { Box } from '../../Box';
import { Typography } from '../../Typography';
import { Icon } from '../../Icon';

import useStyles from './FormKnownValue.styles';

/**
 * Cвойства компонента {@link FormKnownValue}
 */
interface FormKnownValueProps {
  /**
   * Текст метки для поля формы.
   */
  label: string;

  /**
   * Значение поля формы. Может быть строкой или null.
   */
  value?: string | null;

  /**
   * Флаг, указывающий, верифицировано ли значение.
   *
   * @defaultValue `true`
   */
  verified?: boolean;

  /**
   * Подпись для поля формы, которая может отображаться под значением.
   */
  caption?: string | null;
}

/**
 * Компонент для отображения имени поля формы и его значения с возможной меткой верификации и подписью.
 *
 * @public
 * @param label - Текст метки для поля формы.
 * @param value - Значение поля формы. Может быть строкой или null.
 * @param verified - Флаг, указывающий, верифицировано ли значение.
 * @param caption - Подпись для поля формы, которая может отображаться под значением.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link FormKnownValueProps}
 */
export const FormKnownValue = ({
  label,
  value,
  verified = true,
  caption,
}: FormKnownValueProps) => {
  const { classes } = useStyles();

  return (
    <Box>
      <InputLabel className={classes.label}>{label}</InputLabel>
      <Box display="flex" justifyContent="start" alignItems="center">
        <Typography variant="body2">{value || ''}</Typography>

        {verified && (
          <Box ml="8" display="flex" alignItems="center">
            <Icon
              name="check_circle_large"
              size="16"
              color="original.brand.primary"
            />
          </Box>
        )}
      </Box>
      {caption && <span className={classes.caption}>{caption}</span>}
    </Box>
  );
};
